import dateUtils from '@/common/dateUtils';
const dateTimeMixin = {
  methods: {
    toLocaleString(date) {
      return dateUtils.formatAsLocaleLongDate(date);
    },

    formatDate(isoDateString) {
      let date = dateUtils.parseISOString(isoDateString);
      return dateUtils.formatAsLocaleLongDate(date);
    },
    formatAsLocaleShortDate: (date) => dateUtils.formatAsLocaleShortDate(date),
    formatAsLocaleDateTime: (date) => dateUtils.formatAsLocaleDateTime(date),
    formatAsLocaleDayAndMonth: (date) => dateUtils.formatAsLocaleDayAndMonth(date),
    /**
     * Formats an ISO date string as a locale date.
     *
     * @param {string} isoDateString - The ISO date string to format.
     * @param {string} [locale='de-CH'] - The locale to use for formatting the date.
     * @return {string} The formatted locale date string.
     */
    formatIsoDateStringAsLocaleDate(isoDateString, locale = 'de-CH') {
      let date = dateUtils.parseISOString(isoDateString);
      return dateUtils.formatAsLocaleLongDate(date, locale);
    },
    formatIsoDateStringAsLocaleShortDate(isoDateString) {
      let date = dateUtils.parseISOString(isoDateString);
      if (isNaN(date)) {
        return `no date ${isoDateString}`;
      }
      return dateUtils.formatAsLocaleShortDate(date);
    },
    mx_formatIsoDateStringAsLocaleDateTime(isoDateString) {
      return dateUtils.formatAsLocaleShortDateTime(isoDateString);
    },
    mx_getMinutesAfterMidnightFromTime(timeHHMM) {
      return dateUtils.getMinutesAfterMidnightFromTime(timeHHMM);
    },
    getTimeFromMinutesAfterMidnight(timeFormat, minutesAfterMidnight, dateString = '') {
      return dateUtils.getTimeFromMinutesAfterMidnight(timeFormat, minutesAfterMidnight, dateString);
    },
  },
  computed: {
    commonTimeFormat() {
      return this.data;
    },
  },
};

export default dateTimeMixin;
